/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resourceItem.vue?vue&type=template&id=ae86c4ea&scoped=true&"
import script from "./resourceItem.vue?vue&type=script&lang=js&"
export * from "./resourceItem.vue?vue&type=script&lang=js&"
import style0 from "./resourceItem.vue?vue&type=style&index=0&id=ae86c4ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae86c4ea",
  null
  
)

export default component.exports